export default {
  title: 'Recharge',
  price: 'Price {{price}}',
  limit: 'Limited <span>{{time}}</span> offer for {{doniaNo}} please pay as soon as possible',
  rate: '$1 = <span>{{coins}}coins</span>',
  totalCoins: 'Total coins: <span>{{coins}}</span>',
  bonus: 'Bonus',
  discountOff: '{{percent}}% OFF',
  invalidLink: 'Invalid recharge link',
  loadFailed: 'Failed to load recharge information',
};
